export default __webpack_public_path__ + "static/media/015-maps-and-flags-1.c2219de1.png";